import { render, staticRenderFns } from "./setTool.vue?vue&type=template&id=5952d965&scoped=true"
import script from "./setTool.vue?vue&type=script&lang=js"
export * from "./setTool.vue?vue&type=script&lang=js"
import style0 from "./setTool.vue?vue&type=style&index=0&id=5952d965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5952d965",
  null
  
)

export default component.exports